/* globals $ */
(function() {
   
	'use strict';
    angular
        .module('quantixApp')
        .filter('highlight', highlight);
        
    
  
    highlight.$inject = ['$sce'];
    
     function highlight (sce) {
    	 
    	 return function (input, searchParam) {
    	    if (typeof input === 'function') return '';
    	    if (searchParam) {
    	      var words = '(' +
    	            searchParam.split(/\ /).join(' |') + '|' +
    	            searchParam.split(/\ /).join('|') +
    	          ')',
    	          exp = new RegExp(words, 'gi');
    	      if (words.length) {
    	        input = input.replace(exp, "<span class=\"highlight\">$1</span>");
    	      }
    	    }
    	    return sce.trustAsHtml(input);
    	  };
    }
})();


